module.exports = __webpack_public_path__ + "teqbahn-assets/media/22.6670c360.png";